const COLORS = ['#c8ff4d', '#ff5267', '#31d1f5', '#ffcf20', '#a78bff', '#ffffff'];

export function Confetti({ active }: { active: boolean }) {
  if (!active) return null;
  return (
    <div className="confetti" aria-hidden="true">
      {Array.from({ length: 34 }, (_, index) => {
        const left = (index * 29) % 100;
        const delay = (index % 12) * 0.11;
        const duration = 2.4 + (index % 7) * 0.22;
        const color = COLORS[index % COLORS.length];
        return (
          <span
            key={index}
            style={{
              left: `${left}%`,
              animationDelay: `${delay}s`,
              animationDuration: `${duration}s`,
              background: color,
              width: index % 3 === 0 ? 8 : 5,
              height: index % 4 === 0 ? 14 : 9,
              transform: `rotate(${index * 31}deg)`,
            }}
          />
        );
      })}
    </div>
  );
}
